import { cn } from '@eigtech/ui/lib/utils'
import { Microphone } from './Mic'

export type MicVolumeIndicatorProps = {
  className?: string
  iconClassName?: string
  /* Whether or not the attendee is muted */
  muted?: boolean | undefined
  /* The measure of an attendee's network connection on a scale of 0 to 1.
  A bad connection is .5 or below. */
  signalStrength: number | undefined
  ref: React.Ref<HTMLDivElement>
}

export function MicVolumeIndicator({
  ref,
  className,
  iconClassName,
  muted = false,
  signalStrength,
}: MicVolumeIndicatorProps) {
  const poorConnection = signalStrength !== undefined && signalStrength <= 0.5

  return (
    <div className={cn('relative leading-0', className)}>
      <Microphone
        className={cn('relative z-[2]', iconClassName)}
        muted={muted}
        poorConnection={poorConnection}
      />
      <div className="absolute bottom-[39%] left-[39%] h-[38%] w-[21%] overflow-hidden rounded-[20%]">
        <div
          ref={ref}
          className={cn(
            !!signalStrength && signalStrength <= 0.5 ? 'bg-red-500' : 'bg-white',
            'absolute top-0 right-0 bottom-0 left-0 origin-bottom will-change-transform'
          )}
        />
      </div>
    </div>
  )
}
